export { EventDetail, getEventCoverImage } from './event-detail';
